module.exports = __webpack_public_path__ + "img/1776.c8961812.gif";